export default __webpack_public_path__ + "static/media/detalle-entrega.b896efda.png";